export default {
    methods: {
        save() {
            this.$store.dispatch('companiesModify', this.company)
        },
    },
}
